module.exports = __webpack_public_path__ + "static/media/rose-p.d43f3c5e.svg";